
// Keys of the object will be the theme names 
// their values will be the CSS classes associated with the theme.
export const theme: { [key: string]: string } = {
    light: 'light-theme',
    dark: 'dark-theme',
  };